import { render, staticRenderFns } from "./PostCoverPreview.vue?vue&type=template&id=8452473e&scoped=true&"
import script from "./PostCoverPreview.vue?vue&type=script&lang=js&"
export * from "./PostCoverPreview.vue?vue&type=script&lang=js&"
import style0 from "./PostCoverPreview.vue?vue&type=style&index=0&id=8452473e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8452473e",
  null
  
)

export default component.exports